module.exports = __webpack_public_path__ + "static/img/zh1.e23da21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhsh/zh1.png
// module id = 99lg
// module chunks = 13